import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

export const updateThreshold = async (threshold) => {
    try {

        const response = await axios.post(`${apiUrl}/sensors/update-threshold`, threshold, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response;
    } catch (error) {
        console.error(`Error al actualizar threshold `, error);
        throw error; // Propaga el error para manejarlo en el componente
    }
}

export const getMeasurements = async (idSensor, idVariable, startDate, endDate) => {
    try {
        const response = await axios.get(`${apiUrl}/sensors/measurements`, {
            params: {
                idSensor,
                idVariable,
                startDate,
                endDate,
                recursive: true,
            },
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response;
    } catch (error) {
        console.error('Error al obtener medidas', error);
        throw error; // Propaga el error para manejarlo en el componente
    }
};

export const getDailyMeasurements = async (idSensor, idVariable, startDate, endDate) => {

    try {
        const response = await axios.get(`${apiUrl}/daily/measurements`, {
            params: {
                idSensor,
                idVariable,
                startDate,
                endDate,
            },
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response;
    } catch (error) {
        console.error('Error al obtener medidas', error);
        throw error; // Propaga el error para manejarlo en el componente
    }
};

export const getIrrigationEvents = async (idSensor, date) => {
    // Convert to Date object to extract year, month, and day
    const d = new Date(date);
    // Use UTC components to ensure we get the same day regardless of browser timezone
    const year = d.getUTCFullYear();
    const month = String(d.getUTCMonth() + 1).padStart(2, '0');
    const day = String(d.getUTCDate()).padStart(2, '0');

    const dateStr = `${year}-${month}-${day}`;

    // Construct local time range with Colombia's GMT-5 offset
    const startRange = `${dateStr}T00:00:00.000-05:00`;
    const endRange = `${dateStr}T23:59:59.999-05:00`;

    try {
        const response = await axios.get(`${apiUrl}/irrigation/events`, {
            params: {
                idSensor,
                startDate: startRange,
                endDate: endRange
            },
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
            },
        });

        return response;
    } catch (error) {
        console.error('Error al obtener eventos de riego', error);
        throw error;
    }
};
